import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Bold = styled.strong`
  font-weight: ${theme.font.weight.semiBold};
`;

export const Code = styled.code`
  font-family: Roboto Mono;
  background-color: ${theme.color.designSystem.grey20};
  color: ${theme.color.designSystem.purple90};
`;

export type ColourProps = {
  colour: string | undefined;
};

export const Colour = styled.span`
  color: ${({ colour }: ColourProps) => colour};

  a & {
    text-decoration: underline;
  }
`;
